import { Amplify } from 'aws-amplify';

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_ragThSsZv',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '25a7efnnf11s62t08aubuvp3d5',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'sna-test-am-apps.auth.us-east-1.amazoncognito.com',
          scopes: ['openid', 'profile'],
          redirectSignIn: ['http://localhost:3000/callback', `https://${process.env.REACT_APP_CALLBACK_URL || 'd1v0agjul2x01u.cloudfront.net'}/callback`],
          redirectSignOut: ['http://localhost:3000', `https://${process.env.REACT_APP_CALLBACK_URL || 'd1v0agjul2x01u.cloudfront.net'}`],
          responseType: 'code'
        }
      }
    }
  }
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;